


import React, { Component } from "react";
import Button from "../../components/bases/button/button";
import DialogSelectConf from "../appcode/confmanager/dialogselect";
import { apiReadOneConfiguration } from "../../utils/apis";
import { GlobalContext } from "../../utils/globalprovider";

import imgsearch from "./assets/search.png"
import { createPortal } from "react-dom";

class SelectConfigInput extends React.Component
{
    
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            coid: this.props.coid, // coid en cours
            conf: {coid:0, coname:""},
            errmsg: this.props.errmsg,
            displayDialogSelectConfig: false,
        }


        this.onConfigLoaded = this.onConfigLoaded.bind(this);
        this.onselect = this.onselect.bind(this);
        this.onvalidconf = this.onvalidconf.bind(this);
        

    }


    onConfigLoaded(datas)
    {
        if (Array.isArray(datas))
            if (datas.length > 0)
                this.setState({ conf: datas[0]})
        
    }


    componentDidMount()
    {
        if (this.state.coid > 0)
            apiReadOneConfiguration (this.state.coid, this.onConfigLoaded);
    }


    getValue()
    {
        return this.state.coid;
    }


    onvalidconf(datas)
    {
        
        
        if (datas.ret)
            this.setState({displayDialogSelectConfig:false, coid: datas.datas.datas.coid, conf: datas.datas.datas});
        else
            this.setState({displayDialogSelectConfig:false})
    }
    onselect()
    {
        this.setState({displayDialogSelectConfig:true})
    }

    

    render()
    {

        var msg = "???";
        if (this.state.coid < 1)
            msg = this.context.language=="fr"?"Configuration par défaut.":"Default configuration.";
        else
        {
            msg = this.state.conf.coid +" "+this.state.conf.coname;
            
        }

        var addtables = []
    
        if (this.state.displayDialogSelectConfig)
            addtables.push(<DialogSelectConf conf = {this.state.conf} onvalidform={this.onvalidconf} closebutton = {true} zindex={2} display = {this.state.displayDialogSelectConfig} />)

        return (<>
            {addtables}
            <div className = "dialog-Input-Title">
                {this.props.title}
            </div>

            <div style={{display:"flex", flexDirection:"row"}}>
                <div className="dialog-Table-Datas" style={{width: this.props.width - 32}}>
                    &nbsp;{msg}
                </div>
                <div>
                    
                {!this.props.readOnly?
                    (<Button tooltip={this.context.language=="fr"?"Sélectionner une configuration.":"Select configuration."} 
                        image={imgsearch} width={20} height={20} disable={this.props.readOnly}
                        button={true} onClick={ () =>this.onselect()} 
                        />):(<></>)
                }
                </div>
            </div>
            

            
        </>);
    
    }

}
SelectConfigInput.defaultProps = 
{
    align: "left",
    lib: "",
    disabled: false,
    errmsg: "",
    readOnly: false,
}

export default SelectConfigInput